export enum PaymentTypeEnum {
    terms = 'terms',
    prepay = 'prepay',
    credit = 'credit'
}
